<template>
	<basket-line
			:title="title"
			:price="product.price"
			:amount="product.amountOrdered"
			:discount-price="discountPrice"
			:action-label="actionLabel"
			:heading-level="4"
			:show-action-label="showDiscountPeriodLabel"
			:compact="compact"
	/>
</template>

<script setup lang="ts">
	import type {Product} from '@/types/product';
	import {computed} from 'vue';
	import BasketLine from '@/components/basket/BasketLine.vue';
	import {getActionPeriodLabelText} from '@/utils/textFormatter';

	interface Props {
		product: Product,
		showDiscountPeriodLabel?: boolean,
		compact?: boolean
	}

	const props = withDefaults(defineProps<Props>(), {
		showDiscountPeriodLabel: false,
		compact: true
	});

	const title = computed(() => {
		if (props.product.amountOrdered > 1) {
			return `${props.product.amountOrdered}× ${props.product.title}`;
		}
		return `${props.product.title}`;
	});

	const discountPrice = computed(() => {
		if (props.product.discountApplicable) {
			return props.product.discount?.price ?? undefined;
		}

		return undefined;
	});

	const actionLabel = computed(() => getActionPeriodLabelText(props.product.discount));
</script>
